module.exports = __webpack_public_path__ + "img/CNCEC.e4f69b2f.png";